import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
  buttonCancelSpacing: css`
    padding-left: 16px;
  `,
  searchContainer: css`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 16px 16px 24px;
    color: ${colors.prussian};
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.25);
  `,
  section: css`
    padding: 0px 16px 0px 16px;
  `,
  tabHeaderSpacing: css`
    margin-top: 24px;
  `,
  searchForPadding: css`
    padding-bottom: 16px;
  `,
  content: css`
    flex-grow: 1;
  `,
  text: css`
    font-size: 13px;
    color: ${colors.prussian};
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: none;
    cursor: pointer;
  `,
  textSearch: css`
    padding-bottom: 16px;
  `,
  expiredFlyersSpacing: css`
    padding-top: 32px;
  `,
  viewExpiredButton: css`
    text-transform: none !important;
  `,
  dividerPadding: css`
    padding: 16px 0px;
  `,
  headerContainer: css`
    padding-bottom: 12px;
  `,
  currentFlyerHeader: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 0px 12px;
    /* padding-bottom: 12px; */
  `,
};

export default styles;
